import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ToolSidebarConfiguration } from './tool-sidebar-configuration.model';

@Injectable()
export class ToolSidebarService {
    sidebarConfiguration: BehaviorSubject<ToolSidebarConfiguration> = new BehaviorSubject<ToolSidebarConfiguration>(null);

    constructor() {
        this.reset();
    }

    updateTitle(newTitle) {
        this.sidebarConfiguration.next({
            ...this.sidebarConfiguration.value, sidebarView: {
                ...this.sidebarConfiguration.value.sidebarView,
                title: newTitle
            }
        });
    }

    toggleSidebar() {
        this.sidebarConfiguration.next({
            ...this.sidebarConfiguration.value, sidebarView: {
                ... this.sidebarConfiguration.value.sidebarView,
                toggled: !this.sidebarConfiguration.value.sidebarView.toggled
            }
        });
    }

    show(showState: boolean = true) {
        this.sidebarConfiguration.next({
            ...this.sidebarConfiguration.value, sidebarView: {
                ... this.sidebarConfiguration.value.sidebarView,
                show: showState
            }
        });
    }

    hide() {
        this.show(false);
    }

    reset() {
        this.sidebarConfiguration.next({
            sidebarView: {
                title: 'Tools',
                toggled: false,
                show: false
            },
            sidebarItems: []
        });
    }
}
